<template>
  <div class="mainentrance">
    <div class="container-fluid h-100">
      <b-row class="tb">
        <b-col cols="12" md="4" class="m-borders online-consultation">
          <div class="row h-100">
            <div class="col-sm-12 align-self-center py-3">
              <div>
                <h2>{{ $t("main-screen.online_consultation.title") }}</h2>
                <b-button
                  squared
                  variant="light"
                  size="md"
                  class="main-button shadow"
                  to="onlineconsultation/"
                  >{{ $t("main-screen.online_consultation.button_text") }}
                </b-button>
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12" md="4">
          <div class="row h-50 background-onlinestore m-borders">
            <b-col class="col-sm-12 align-self-center py-3">
              <div>
                <h2>{{ $t("main-screen.online.title") }}</h2>
                <!-- <p>{{ $t('main-screen.online.description') }}</p> -->
                <b-button
                  squared
                  variant="light"
                  size="md"
                  class="main-button shadow"
                  href="https://moncoachbeaute.ca"
                  target="_blank"
                  >{{ $t("main-screen.online.button_text") }}</b-button
                >
              </div>
            </b-col>
          </div>
          <div class="row h-50 background-athome m-borders">
            <div class="col-sm-12 align-self-center py-3">
              <div>
                <h2>{{ $t("main-screen.at-home.title") }}</h2>
                <!-- <p>{{ $t('main-screen.at-home.description') }}</p> -->
                <b-button
                  squared
                  variant="light"
                  size="md"
                  class="main-button shadow"
                  to="at-home/"
                  >{{ $t("main-screen.at-home.button_text") }}</b-button
                >
              </div>
            </div>
          </div>
        </b-col>

        <b-col cols="12" md="4" class="m-borders retail-clinic">
          <div class="row h-100">
            <div class="col-sm-12 align-self-center py-3">
              <div>
                <h2>{{ $t("main-screen.retail.title") }}</h2>
                <!-- <p>{{ $t('main-screen.retail.description') }}</p> -->
                <b-button
                  squared
                  variant="light"
                  size="md"
                  class="main-button shadow"
                  to="clinic/"
                  >{{ $t("main-screen.retail.button_text") }}</b-button
                >
              </div>
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row class="tb2">
        <b-col cols="12" md="4" class="background-assessment m-borders">
          <div class="row h-100">
            <div class="col-sm-12 align-self-center py-3">
              <div>
                <h2>{{ $t("main-screen.skincare_assessment.title") }}</h2>
                <b-button
                  squared
                  variant="light"
                  size="md"
                  class="main-button shadow"
                  to="/online/assessment/routine"
                  >{{
                    $t("main-screen.skincare_assessment.button_text")
                  }}</b-button
                >
              </div>
            </div>
          </div>
        </b-col>
        <b-col>
          <div
            class="row h-100 m-borders background-searchproducts"
            style="background-color: black"
          >
            <div class="col-sm-12 align-self-center py-3">
              <div>
                <h2>{{ $t("main-screen.search_products.title") }}</h2>
                <b-form-input
                  type="search"
                  name="search"
                  style="height: 35px"
                  v-model="searchProductName"
                  placeholder="Recherche de produits..."
                ></b-form-input>
                <b-button
                  squared
                  variant="light"
                  size="md"
                  class="main-button shadow mt-2"
                  @click.prevent="searchProducts()"
                  >{{ $t("main-screen.blog.button_text") }}</b-button
                >
              </div>
            </div>
          </div>
        </b-col>
        <b-col>
          <div class="row h-100 background-social m-borders">
            <div class="col-sm-12 align-self-center py-3">
              <div>
                <h2>{{ $t("main-screen.social.title") }}</h2>
                <b-button
                  squared
                  variant="transparent"
                  size="md"
                  class="main-button"
                  v-on:click="social"
                >
                  <i
                    class="fa fa-facebook-official fa-2x mx-1"
                    style="color: white"
                  ></i>
                  <i
                    class="fa fa-instagram fa-2x mx-1"
                    style="color: white"
                  ></i>
                  <i class="fa fa-twitter fa-2x mx-1" style="color: white"></i>
                </b-button>
              </div>
            </div>
          </div>
        </b-col>
        <b-col>
          <div class="row h-100 background-tutorials m-borders">
            <div class="col-sm-12 align-self-center py-3">
              <div>
                <h2>{{ $t("main-screen.blog.title") }}</h2>
                <b-button
                  squared
                  variant="light"
                  size="md"
                  class="main-button shadow"
                  to="/blog/"
                  >{{ $t("main-screen.blog.button_text") }}</b-button
                >
              </div>
            </div>
          </div>
        </b-col>
        <b-col>
          <div class="row h-100 m-borders" style="background-color: #808080">
            <div class="col-sm-12 align-self-center py-3">
              <div>
                <h2>{{ $t("main-screen.faqs.title") }}</h2>
                <b-button
                  squared
                  variant="light"
                  size="md"
                  class="main-button shadow"
                  to="/faqs/"
                  >{{ $t("main-screen.faqs.button_text") }}</b-button
                >
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

// <script>
function flattenRoutes(routes, basePath = "") {
  const flattenedRoutes = [];

  for (const route of routes) {
    // Handle the case when route has an alias
    if (route.alias) {
      flattenedRoutes.push({ ...route, path: basePath + route.alias });
    }

    const newPath = basePath + route.path;
    flattenedRoutes.push({ ...route, path: newPath });

    // If the route has children, recursively flatten them
    if (route.children) {
      const childRoutes = flattenRoutes(route.children, newPath);
      flattenedRoutes.push(...childRoutes);
    }
  }

  return flattenedRoutes;
}

export default {
  name: "mainentrance",
  data() {
    return {
      msg: "Welcome to BI",
      searchProductName: "",
    };
  },
  methods: {
    social() {
      this.$router.push({ name: "social" });
    },
    searchProducts() {
      window.location.href =
        "https://moncoachbeaute.ca/search?q=" + this.searchProductName;
      this.searchProductName = "";
    },
  },
  mounted() {
    const routes = this.$router.options.routes;
    const flattenedRoutes = flattenRoutes(routes);
    console.log("Flattened route list:", flattenedRoutes);
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mainentrance {
  text-align: center;
}
.tb {
  min-height: calc(90vh * 0.66);
}
.tb2 {
  min-height: calc(90vh * 0.33);
}
.m-borders {
  border: 3px solid white;
}
.b-borders {
  border: 1px solid black;
}
.retail-clinic {
  background-image: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.2)),
    url("../assets/images/service_facial.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.online-consultation {
  background-image: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.2)),
    url("../assets/images/onlineconsult.jpeg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-color: black;
}
.background-onlinestore {
  background-image: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.2)),
    url("../assets/images/onlinestore3.jpeg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.background-athome {
  background-image: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.2)),
    url("../assets/images/athome2.jpeg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  color: black !important;
}
.background-assessment {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.3)),
    url("../assets/images/formulary.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.background-tutorials {
  background-image: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.2)),
    url("../assets/images/m_tutorial.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.background-searchproducts {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.2)),
    url("../assets/images/onlinestore1.jpeg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: "cover";
}

.background-social {
  /* background-image: linear-gradient(rgba(0, 0, 0, 0.5),
                       rgba(0, 0, 0, 0.3)), url('../assets/images/onlinestore2.jpg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 'cover'; */
  /* background-color:#E8E8E8; */
  background-color: black;
  color: white;
}
h2 {
  color: white;
  font-weight: 400;
}
p {
  color: white;
}
.search-container button {
  padding: 6px 10px;
  margin-right: 0px;
  background: #ddd;
  font-size: 16px;
  border: none;
  cursor: pointer;
}
.search-container input[type="text"] {
  padding: 6px;
  margin-top: 8px;
  font-size: 16px;
  border: none;
}
.main-button {
  min-width: 175px;
  text-transform: uppercase;
}
@media only screen and (max-width: 600px) {
  .row {
    min-height: 300px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Main.vue